var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivityActive = function SvgActivityActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.227 1.975H3.564C2.7 1.975 2 2.675 2 3.54v16.597C2 21 2.7 21.7 3.564 21.7h14.663c.863 0 1.564-.7 1.564-1.564V3.539c0-.864-.7-1.564-1.564-1.564Z",
    fill: "#D1B896"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.688 7.817h-9.59v.85h9.59v-.85ZM15.688 10.216h-9.59v.85h9.59v-.85ZM15.688 12.61h-9.59v.849h9.59v-.85ZM12.095 15.008H6.098v.85h5.997v-.85Z",
    fill: "#DAC6AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.578 25.553a1.395 1.395 0 0 1-2 0l-4.227-4.228a1.394 1.394 0 0 1 .987-2.383 1.396 1.396 0 0 1 .987.41l4.228 4.227a1.393 1.393 0 0 1 .025 1.974Z",
    fill: "#E3D4C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 19.676a5.408 5.408 0 0 1 0-8.57 5.422 5.422 0 0 1 6.581 0 5.41 5.41 0 0 1 0 8.575 5.412 5.412 0 0 1-6.581-.005Z",
    fill: "#FDF8F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.217 10.795H8.812l1.963-.85h6.442v.85ZM17.222 12.345h-8.41v.85h8.41v-.85ZM17.222 14.744h-8.41v.85h8.41v-.85ZM14.069 17.142H8.812v.85h5.257v-.85Z",
    fill: "#D1B896"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m25.553 23.554-2.184-2.184a2.948 2.948 0 0 1-.7-3.138 7.79 7.79 0 0 0-1.629-8.236 7.856 7.856 0 0 0-10.824-.41 7.806 7.806 0 0 0-.31 11.32 7.807 7.807 0 0 0 8.34 1.744 2.999 2.999 0 0 1 3.169.714l2.189 2.189a1.393 1.393 0 0 0 2.159-.225 1.418 1.418 0 0 0-.21-1.774Zm-13.428-3.878a5.407 5.407 0 0 1 0-8.57 5.422 5.422 0 0 1 6.581 0 5.413 5.413 0 0 1 0 8.575 5.412 5.412 0 0 1-6.581-.005Z",
    fill: "#E3D4C0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m24.253 22.254-1.998 2 1.324 1.324a1.395 1.395 0 0 0 1.999 0 1.394 1.394 0 0 0 0-2l-1.325-1.324Z",
    fill: "#D1B896"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m24.248 22.253-1.972 1.972.597.597 1.972-1.972-.597-.597Z",
    fill: "#A79378"
  })));
};
export default SvgActivityActive;